import React, { useEffect, useState } from 'react'

import { Pie as AtnPie } from '@ant-design/charts'

interface PieProps {
  data: ChartDataType[]
  statistics: {
    title: string
    content: string
  }
  width?: number
  height?: number
  style?: {
    statisticTitle?: any
    statisticContent?: any
  }
  loading?: boolean
}

export type ChartDataType = {
  type: string
  value: number
  color: string
}

const Pie = ({ data = [], statistics, ...props }: PieProps): JSX.Element => {
  const [pieData, setPieData] = useState<Record<string, any>[]>(data)
  const [colors, setColors] = useState<string[]>([])

  useEffect(() => {
    if (data.length === 1) {
      let tempData = [
        ...data,
        {
          type: '',
          value: 100 - data[0].value,
          color: '#D3D9E0',
        },
      ]

      setPieData(tempData)

      let tempColors = []

      tempData.forEach((i) => {
        tempColors.push(i.color)
      })

      setColors(tempColors)
    }
  }, [data])

  return (
    <div>
      {/* @ts-ignore */}
      <AtnPie
        width={120}
        height={120}
        appendPadding={10}
        data={pieData}
        angleField="value"
        colorField="type"
        radius={1}
        innerRadius={0.8}
        label={{
          type: 'inner',
          offset: '-50%',
          content: '{value}',
          style: {
            textAlign: 'center',
            fontSize: 14,
            opacity: 0,
          },
        }}
        interactions={[
          {
            type: 'element-selected',
            enable: false,
          },
          {
            type: 'element-active',
            enable: false,
          },
          {
            type: 'tooltip',
            enable: false,
          },
        ]}
        legend={false}
        color={colors}
        statistic={{
          title: {
            content: statistics.title,
            style: {
              fontSize: '11px',
              color: props?.style?.statisticTitle?.color || '#858C96',
              ...props?.style?.statisticTitle,
            },
          },
          content: {
            content: statistics.content,
            style: {
              whiteSpace: 'pre-wrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontSize: '16px',
              fontWeight: 'regular',
              color: props?.style?.statisticContent?.color || '#27292C',
              ...props?.style?.statisticContent,
            },
          },
        }}
        {...props}
      />
    </div>
  )
}

export default Pie
